/*
 * Identity Boutik — storefront enhancements
 *
 * 1. Free shipping progress bar in the cart drawer and cart page.
 * 2. Low-stock-only inventory line on product pages.
 *
 * TO CHANGE THE SHIPPING THRESHOLD: edit THRESHOLD below (major units).
 * It MUST match the free-shipping rate in Settings > Shipping and delivery,
 * for BOTH the Domestic and Bahamas zones. Currently $125.
 */
(function () {
  'use strict';

  var THRESHOLD = 125; // dollars
  var MOUNT_CLASS = 'ib-ship';

  function money(cents) {
    var amount = cents / 100;
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
    } catch (e) { /* fall through */ }
    return '$' + amount.toFixed(2);
  }

  function injectStyles() {
    if (document.getElementById('ib-ship-styles')) return;
    var css =
      '.' + MOUNT_CLASS + '{padding:14px 0 16px;font-size:1.3rem;line-height:1.45;}' +
      '.' + MOUNT_CLASS + '__msg{margin:0 0 8px;letter-spacing:.02em;}' +
      '.' + MOUNT_CLASS + '__msg strong{font-weight:600;}' +
      '.' + MOUNT_CLASS + '__track{position:relative;height:4px;border-radius:2px;' +
      'background:rgba(var(--color-foreground,26,26,26),.14);overflow:hidden;}' +
      '.' + MOUNT_CLASS + '__fill{position:absolute;inset:0 auto 0 0;width:0;border-radius:2px;' +
      'background:#c1a66d;transition:width .4s ease;}' +
      '.' + MOUNT_CLASS + '--done .' + MOUNT_CLASS + '__fill{background:#1a1a1a;}' +
      '@media (prefers-reduced-motion:reduce){.' + MOUNT_CLASS + '__fill{transition:none;}}';
    var style = document.createElement('style');
    style.id = 'ib-ship-styles';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function targets() {
    var found = [];
    var drawer = document.querySelector(
      'cart-drawer .drawer__footer, .cart-drawer__footer, #CartDrawer .drawer__footer'
    );
    if (drawer) found.push(drawer);
    var page = document.querySelector('.cart__footer .cart__blocks, .cart__footer');
    if (page && page !== drawer) found.push(page);
    return found;
  }

  function markup(total) {
    var thresholdCents = THRESHOLD * 100;
    var pct = Math.min(100, Math.round((total / thresholdCents) * 100));
    var remaining = thresholdCents - total;
    var msg;
    if (total <= 0) {
      msg = 'Free shipping on orders over <strong>' + money(thresholdCents) + '</strong>.';
    } else if (remaining > 0) {
      msg = 'You’re <strong>' + money(remaining) + '</strong> away from free shipping.';
    } else {
      msg = '<strong>You’ve unlocked free shipping.</strong>';
    }
    return {
      html:
        '<p class="' + MOUNT_CLASS + '__msg">' + msg + '</p>' +
        '<div class="' + MOUNT_CLASS + '__track" role="progressbar" aria-valuemin="0" ' +
        'aria-valuemax="100" aria-valuenow="' + pct + '" aria-label="Progress toward free shipping">' +
        '<span class="' + MOUNT_CLASS + '__fill" style="width:' + pct + '%"></span></div>',
      done: remaining <= 0
    };
  }

  function render(total) {
    injectStyles();
    var content = markup(total);
    targets().forEach(function (host) {
      var el = host.querySelector('.' + MOUNT_CLASS);
      if (!el) {
        el = document.createElement('div');
        el.className = MOUNT_CLASS;
        host.insertBefore(el, host.firstChild);
      }
      el.classList.toggle(MOUNT_CLASS + '--done', content.done);
      el.innerHTML = content.html;
    });
  }

  var pending = null;
  function refresh() {
    if (pending) return pending;
    pending = fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) render(cart.total_price); })
      .catch(function () { /* leave the cart alone on failure */ })
      .then(function () { pending = null; });
    return pending;
  }

  /*
   * Dawn's inventory block prints "32 in stock" on healthy products, which is
   * noise and publishes stock levels we would rather not. Keep the line only
   * when it says something a customer can act on: low stock, or unavailable.
   */
  var KEEP = /low stock|out of stock|sold out|unavailable/i;
  function pruneInventory() {
    var nodes = document.querySelectorAll('.product__inventory');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var show = KEEP.test((el.textContent || '').trim());
      if (el.dataset.ibPruned === (show ? 'show' : 'hide')) continue;
      el.dataset.ibPruned = show ? 'show' : 'hide';
      el.style.display = show ? '' : 'none';
    }
  }

  // Re-run the cart bar whenever the cart changes.
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var url = arguments[0];
      var href = typeof url === 'string' ? url : (url && url.url) || '';
      var call = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(href)) {
        call.then(function () { setTimeout(refresh, 60); }).catch(function () {});
      }
      return call;
    };
  }

  function boot() { refresh(); pruneInventory(); }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();

  // The drawer is re-rendered on open and the inventory line on variant change.
  var queued = false;
  var observer = new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      pruneInventory();
      if (targets().length && !document.querySelector('.' + MOUNT_CLASS)) refresh();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
